import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-[400px] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }
const _hoisted_2 = { class: "flex flex-col gap-y-3 px-4 py-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-base text-gray-700"
}
const _hoisted_4 = { class: "border-t border-gray-100 flex flex-col py-3 max-h-[210px] overflow-y-auto" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-between items-center px-6 py-1"
}
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "truncate" }
const _hoisted_9 = {
  key: 1,
  class: "text-sm text-gray-700"
}

import { ref, computed } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import { SearchIcon } from "@heroicons/vue/outline"
import { CheckIcon } from "@heroicons/vue/solid"

interface Props {
    modelValue?: any
    value?: any
    options: any[]
    multiple?: boolean
    optionAttribute?: string
    returnAttribute?: string
    title?: string
    isLoading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GgmsSearchDropdown',
  props: {
    modelValue: {},
    value: {},
    options: {},
    multiple: { type: Boolean },
    optionAttribute: {},
    returnAttribute: {},
    title: {},
    isLoading: { type: Boolean }
  },
  emits: ["update:modelValue", "onSelect"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const overlayPanel = ref()
const search = ref("")
const filteredOptions = computed(() =>
    search.value === ""
        ? props.options
        : props.options.filter((option) =>
              getOptionText(option)
                  ?.toLowerCase()
                  .includes(search?.value?.toLowerCase() || "")
          )
)

const selectedOption = computed({
    get() {
        return props.modelValue || props.value
    },
    set(value) {
        emits("update:modelValue", value)
        emits("onSelect", value)
        overlayPanel.value.hide()
        search.value = ""
    },
})

function selectOption(option: any) {
    selectedOption.value = option
}

function getOptionValue(option: any) {
    return props.optionAttribute && props.returnAttribute ? option[props.returnAttribute] : option
}

function getOptionText(option: any) {
    return props.optionAttribute ? option[props.optionAttribute] : option
}

function toggleOverlayPanel(event: Event) {
    search.value = ""
    overlayPanel.value.toggle(event)
}

function isSelectedOption(option: any) {
    if (typeof option === "object") {
        return option._id === selectedOption.value._id
    }
    return option === selectedOption.value
}

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", {
      toggle: toggleOverlayPanel,
      visible: overlayPanel.value?.visible
    }, () => [
      _createElementVNode("div", { onClick: toggleOverlayPanel }, "Click me")
    ]),
    _createVNode(_component_OverlayPanel, {
      ref_key: "overlayPanel",
      ref: overlayPanel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            _createVNode(GgmsInput, {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              iconStart: _unref(SearchIcon),
              placeholder: "Search",
              styleType: "secondary"
            }, null, 8, ["modelValue", "iconStart"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (filteredOptions.value.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (getOptionText(selectedOption.value))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(getOptionText(selectedOption.value)), 1),
                              _createVNode(_unref(CheckIcon), {
                                class: "h-5 w-5 min-h-[20px] min-w-[20px] text-primary-color-500",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (!isSelectedOption(option))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "flex gap-3 items-center px-6 py-1 cursor-pointer hover:bg-primary-color-100",
                                  onClick: ($event: any) => (selectOption(option))
                                }, [
                                  _createElementVNode("span", _hoisted_8, _toDisplayString(getOptionText(option)), 1)
                                ], 8, _hoisted_7))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ], 64))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, "No results found"))
                ], 64))
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})